import Icon from '@components/atoms/icon/icon';
import sanitizer from '@helpers/sanitizer';
import React, { HTMLProps } from 'react';
import { useTranslation } from 'next-i18next';
import { PAGETYPE_TO_TOUCHPOINT } from '@constants/welcome-voucher';
import Tooltip from '@components/atoms/tooltip/tooltip';
import useWelcomeVoucherQuery from '@hooks/user/use-welcome-voucher-query';
import usePageType from '@hooks/use-page-type';
import clsx from 'clsx';
import styles from './welcome-voucher.module.scss';

export type WelcomeVoucherProps = {
  customClass?: string;
} & HTMLProps<HTMLDivElement>;

const WelcomeVoucher: React.FC<WelcomeVoucherProps> = (props) => {
  const { customClass, ...rest } = props;

  const { t } = useTranslation();
  const { pageType } = usePageType();
  const { welcomeVoucher } = useWelcomeVoucherQuery(PAGETYPE_TO_TOUCHPOINT[pageType]);

  return (
    <div
      className={clsx(styles.welcomeVoucher, customClass)}
      {...rest}
    >
      <span className={styles.welcomeVoucher__text}>
        <Icon
          className={styles.welcomeVoucher__icon}
          name="present"
        />
        {welcomeVoucher?.termsAndConditions ? (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizer(welcomeVoucher?.text),
            }}
          />
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: sanitizer(
                t('PRODUCT.DETAILS.WELCOME_VOUCHER', {
                  welcomeVoucher,
                }),
              ),
            }}
          />
        )}
      </span>
      <Tooltip
        delay={0}
        direction="left"
        tooltipContent={
          welcomeVoucher?.termsAndConditions ? (
            <div className={styles.welcomeVoucher__tooltipContentContainer}>{welcomeVoucher.termsAndConditions}</div>
          ) : (
            <div
              className={styles.welcomeVoucher__tooltipContentContainer}
              dangerouslySetInnerHTML={{
                __html: sanitizer(
                  t('PRODUCT.DETAILS.WELCOME_VOUCHER_TOOLTIP', {
                    welcomeVoucher,
                  }),
                ),
              }}
            />
          )
        }
      >
        <Icon
          className={styles.welcomeVoucher__tooltipAnchor}
          name="info"
        />
      </Tooltip>
    </div>
  );
};

export default WelcomeVoucher;
